import React, { useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { format } from "date-fns";
import AppleLogo from "./assets/snapchat.png";
import megaLogo from "./assets/logo.png";
import svgw from "./assets/ww.svg";
import { triggerBase64Download } from "react-base64-downloader";
import withRouter from "../../components/Common/withRouter";
import qrLogo from "./assets/qr.png";
import Api from "../../api/Api";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { useScreenshot } from "use-react-screenshot";

const Publics = (props) => {
  document.title = "Snapchat Ids";

  const [isLoading, setLoading] = React.useState(true);
  const [isError, setError] = React.useState(true);

  const [data, setData] = React.useState([]);
  const [modal, setModal] = React.useState(true);

  const toggle = () => setModal(!modal);

  const ref = useRef(null);
  const [image, takeScreenshot] = useScreenshot();
  const getImage = () => {
    takeScreenshot(ref.current);
  };

  React.useEffect(() => {
    if (image) {
      triggerBase64Download(image, "ScreenshotAppleId");
    }
  }, [image]);

  React.useEffect(() => {
    setLoading(true);
    Api.get(window.location.pathname)
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error("No Snapchat ID please check the url", {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  }, []);

  const copied = () => {
    toast.success("Text Copied", {
      position: "bottom-center",
      autoClose: 500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });
  };

  const formatDateForSafari = (dateValue) => {
    try {
      if (!dateValue) return "N/A"; // Handle null or undefined values

      // If date is in "YYYY-MM-DD HH:MM:SS" format, extract only the date part
      if (typeof dateValue === "string" && dateValue.includes(" ")) {
        return dateValue.split(" ")[0]; // Extract "YYYY-MM-DD"
      }

      // If it's a number (Excel serial date), convert it
      if (!isNaN(dateValue) && dateValue > 0) {
        let excelBaseDate = new Date(1899, 11, 30); // Excel starts from 1899-12-30
        let actualDate = new Date(
          excelBaseDate.getTime() + dateValue * 86400000
        ); // Convert days to milliseconds
        return actualDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
      }

      // If it's a valid date string, try to parse it normally
      let parsedDate = new Date(dateValue);
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
      }

      return "N/A"; // If all parsing fails
    } catch (error) {
      return "N/A"; // Fallback for unexpected errors
    }
  };

  return (
    <React.Fragment>
      <div className="page-content" ref={ref}>
        {isLoading ? (
          <div style={{ textAlign: "center", marginTop: 200 }}>
            <Spinner type="grow">Loading...</Spinner>
          </div>
        ) : (
          <Container fluid>
            {/* <Breadcrumb title="Upzet" breadcrumbItem="Profile" /> */}
            <img
              height={200}
              src={`${
                data.image === "logo.png"
                  ? megaLogo
                  : `https://api.api-apple.com/public/storage/${data.image}`
              }`}
              className="mt-4 mb-4 ml-auto mr-auto d-flex"
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                maxWidth: "100%",
                width: 400,
                height: "auto",
              }}
            />

            <p className="text-center mt-4 mb-4" style={{ fontSize: 16 }}>
              رقم الحساب:{" "}
              <span
                style={{
                  padding: "5px 10px",
                  background: "#000972",
                  color: "#fff",
                  borderRadius: 5,
                }}
              >
                {data?.id}
              </span>
            </p>

            <style>
              @import
              url('https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap');
            </style>

            <Row
              className="justify-content-center"
              style={{ direction: "rtl", fontFamily: "Cairo" }}
            >
              <Col md="6">
                <Card style={{ padding: 15 }}>
                  <CardBody>
                    <Row className="mb-3">
                      <div className="col-md-5">
                        <img
                          height={200}
                          src={AppleLogo}
                          className="mt-4 mb-4 ml-auto mr-auto d-flex hide-on-mobile"
                          style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            width: "50%",
                            height: "auto",
                          }}
                        />
                      </div>
                      <div className="col-md-7">
                        <h5>حساب سناب شات:</h5>
                        <div className="public-apple mb-3">
                          <div className="public-apple-button">
                            <div className="d-block">
                              <h4>الحساب:</h4>
                              <span> {data.email}</span>
                            </div>
                            <CopyToClipboard text={data.email} onCopy={copied}>
                              <i className="ri-file-copy-line align-bottom "></i>
                            </CopyToClipboard>
                          </div>
                          <div className="public-apple-button">
                            <div className="d-block">
                              <h4>الباسورد:</h4>
                              <span> {data.password}</span>
                            </div>
                            <CopyToClipboard
                              text={data.password}
                              onCopy={copied}
                            >
                              <i className="ri-file-copy-line align-bottom "></i>
                            </CopyToClipboard>
                          </div>
                          {/* {data.birthday ? ( */}

                          {/* ) : null} */}
                        </div>
                      </div>
                    </Row>

                    <Row>
                      <div className="col-12 mb-3">
                        {data.purchasedate ? (
                          <div className="col-md-12">
                            <div className="public-apple mb-3">
                              <div className="public-apple-button">
                                <div className="d-block">
                                  <h4>تاريخ الشراء:</h4>
                                  <span>
                                    {" "}
                                    {format(
                                      new Date(data.purchasedate),
                                      "yyyy-MM-dd"
                                    )}
                                  </span>
                                </div>
                                <CopyToClipboard
                                  text={data.purchasedate}
                                  onCopy={copied}
                                >
                                  <i className="ri-file-copy-line align-bottom "></i>
                                </CopyToClipboard>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>

                      {data.shownote ? (
                        <div className="col-12">
                          <h5>ملحوظات:</h5>
                          <div className="public-apple mb-4">
                            <div className="public-apple-button">
                              <CopyToClipboard text={data.note} onCopy={copied}>
                                <>
                                  {data.note}{" "}
                                  <i className="ri-file-copy-line align-bottom "></i>
                                </>
                              </CopyToClipboard>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <Button
                        color="success"
                        className="add-btn"
                        onClick={getImage}
                        id="create-btn"
                      >
                        <i className="ri-screenshot-2-line align-bottom me-1"></i>{" "}
                        حفظ كصورة
                      </Button>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* <Modal isOpen={modal} toggle={toggle} size="lg">
              <ModalBody>
                <p
                  className="text-right"
                  style={{
                    fontSize: 18,
                    textAlign: "right",
                    direction: "rtl",
                  }}
                >
                  <img
                    src={svgw}
                    width="20%"
                    style={{
                      display: "block",
                      margin: "auto",
                      marginBottom: 20,
                    }}
                  />
                  يستخدم الحساب حاليا كـ ابل ايدي فقط وعند استخدام الحساب في
                  الأيكلود يكون على مسؤوليتك الشخصية (وفي هذه الحالة يجب ربط
                  الحساب برقم هاتفك وإيقاف ميزة العثور على الأيفون) • الضمان
                  يشمل استبدال الحساب العاطل قبل استخدمه في الجهاز فقط ولمدة
                  ثلاثة أشهر من تاريخ البيع • بسبب تحديث سياسات شركة أبل
                  الأخيرة، المكتب غير مسؤول عن سوء الاستخدام وينتهي التزامه
                  بتسليم الكارت للمستخدم حيث تقوم الشركة بأغلاق الحسابات التي
                  يقوم بها المستخدم بإدخال معلومات خاطئة • عند شرائك الحساب
                  واتمام عملية تسجيل الدخول تكون مسؤولا عن جميع المعلومات
                  المسجلة للاستخدام والمكتب غير مسؤول عن فقدان الوصول للحساب بعد
                  تسجيل الدخول • عمليات الشراء داخل الحساب غير مكفولة وعلى
                  مسؤوليتك الشخصية • المكتب غير مسؤول بتقديم تعهد بضمان استمرار
                  الخدمات بلا انقطاع او خلل فني من الشركة الام او نتيجة لإيقاف
                  الخدمات بالبلد المستخدم
                </p>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                  اغلاق
                </Button>
              </ModalFooter>
            </Modal> */}
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default withRouter(Publics);
